module.exports = __webpack_public_path__ + "img/text-logo-h144.96724739.png";